import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { CustomInput } from 'reactstrap';
import useOnUnmount from './useOnUnmount';

const RadioGroup = (props) => {
  const [field, meta] = useField(props);
  const readOnly = props.readOnly;
  const name = props.name;

  useOnUnmount(props);

  const options = (props.options || []).filter((o) => {
    if (readOnly && meta.value === o.value) return true;
    else return !o.readOnly;
  });

  return (
    <>
      {options.map((o, i) => (
        <CustomInput
          key={`${o.value}_${i}`}
          id={`${name}_${i}`}
          type='radio'
          name={name}
          onChange={field.onChange}
          value={o.value}
          label={o.label}
          checked={meta.value === o.value}
          disabled={readOnly}
          inline={props.inline}
          invalid={meta.touched && !!meta.error}
          className={props.className}
        />
      ))}
    </>
  );
};
RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      readOnly: PropTypes.bool,
    })
  ),
  readOnly: PropTypes.bool,
  inline: PropTypes.bool,
  onUnmount: PropTypes.func,
};

export default RadioGroup;
